module.exports = __webpack_public_path__ + "assets/images/pressure_g.e40c99ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/pressure_g.png
// module id = 758
// module chunks = 1